import React, { Component } from "react";
import { Header, Grid } from "semantic-ui-react";
import OverviewTableRow from "../OverviewTableRow";
import { OverviewBody, OverviewFooter } from "./style.js";
import _ from "lodash";

export default class OverviewTable extends Component {
  render() {
    const { domainScores, survey, sharedSummaryReport, summaryReport, benchmarkFootnote, landscape, configuration } = this.props;
    const showHospitalDomainScores = !domainScores.unit || !sharedSummaryReport || !sharedSummaryReport.hideHospitalDomainScores;
    const showOverallScore = !domainScores.unit && ((survey === 'SELECT_2020' && summaryReport.id != '18f91942-1324-1ef4-1bd0-15cf11c01f40') || 
      (survey === 'SM_2021' && summaryReport.id != '142614bb-11ad-145d-1f83-141c199b1225') || (survey === 'SM_2022' && summaryReport.id != '1ef59614-da04-48b3-aa5c-3c45b383cbbe') || (survey === 'SM_2023' && summaryReport.id != '49117776-32ce-42aa-b19a-e19ee7b871a2'));
    const cultureScores = _.filter(domainScores.hospital, function(domainScore) {
      if (summaryReport.system === "NYU" && summaryReport.version.major > 1) {
        const domains = [
          "Learning Environment",
          "Local Leadership",
          "Burnout Climate",
          "Personal Burnout",
          "Emotional Recovery",
          "Teamwork",
          "Safety Climate",
        ];
        return domainScore.category === "Culture" && _.includes(domains, domainScore.domain);
      } else {
        return domainScore.category === "Culture";
      }
    }).map( row => ({
      ...row,
      overall: showOverallScore ? row.overall : null
    }));
    const compactRows = cultureScores.length > 7;
    const engagementScores = _.filter(domainScores.hospital, function(domainScore) {
      if (summaryReport.system === "NYU" && summaryReport.version.major > 1) {
        const domains = ["Decision Making"];
        return domainScore.category === "Engagement" && _.includes(domains, domainScore.domain);
      } else {
        return domainScore.category === "Engagement";
      }
    }).map( row => ({
      ...row,
      overall: showOverallScore ? row.overall : null
    }));
    if (domainScores.unit) {
      const unitScores = _.zipObject(_.map(domainScores.unit, "domain"), domainScores.unit);
      for (let i = 0; i < cultureScores.length; i++) {
        cultureScores[i].unit = unitScores[cultureScores[i].domain];
      }
      for (let i = 0; i < engagementScores.length; i++) {
        engagementScores[i].unit = unitScores[engagementScores[i].domain];
      }
    }
    if (domainScores.prevYear) {
      const prevScores = _.zipObject(_.map(domainScores.prevYear, "domain"), domainScores.prevYear);
      for (let i = 0; i < cultureScores.length; i++) {
        cultureScores[i].prevYear = prevScores[cultureScores[i].domain];
      }
      for (let i = 0; i < engagementScores.length; i++) {
        engagementScores[i].prevYear = prevScores[engagementScores[i].domain];
      }
    }

    const shouldShowCultureRow = (row) => {
      if (summaryReport.actualSurvey  === 'VALLEY_2020' || summaryReport.system === 'AMITA') {
        const data = row.unit || row;
        return data && data.domain !== 'Work / Life Balance';
      }

      if (/SOPS/.test(summaryReport.actualSurvey) && !/ASC_SOPS_2023/.test(summaryReport.actualSurvey) && !/BRN/.test(summaryReport.actualSurvey)) {
        const data = row.unit || row;
        return data && data.domain !== 'Burnout Climate' && data.domain !== 'Personal Burnout';
      }
      
      return true;
    }


    const mappedCultureRows = !_.isEmpty(cultureScores) ? (
      cultureScores.filter(shouldShowCultureRow).map(row => (
            <OverviewTableRow
              key={row.domain}
              row={row}
              compact={compactRows}
              showHospitalDomainScores={showHospitalDomainScores}
            />
      ))
    ) : (
      <div />
    );

    const shouldShowEngagementRow = (row) => {
      if (configuration.domain_scores && configuration.domain_scores.showEngagementDomainScores) return true;

      //for indeprov surveys only show these rows
      if (summaryReport.actualSurvey === 'TRINITY_2020_INDPROV' || summaryReport.actualSurvey === 'TRINITY_2021_INDPROV') {
        return ['Intentions to Leave','Decision Making'].indexOf(row.domain) >= 0
      }

      if (summaryReport.actualSurvey === 'TRINITY_2020' || summaryReport.actualSurvey === 'TRINITY_2020_PROV' 
          || summaryReport.actualSurvey === 'TRINITY_2021' || summaryReport.actualSurvey === 'TRINITY_2021_PROV') {
        //only show job certainty when when it has a valid score
        const data = row.unit || row;
        return data && (data.domain !== 'Job Certainty' || data.domain === 'Job Certainty' && data.score !== '--');
      }

      if (summaryReport.system === 'SM') {
        const data = row.unit || row;
        return data && (data.domain !== 'Job Certainty' && data.domain !== 'Intentions to Leave' && data.domain !== 'Advancement')
      }

      return true;
    }

    const mappedEngagementRows = !_.isEmpty(engagementScores) ? (
      engagementScores
      .filter(shouldShowEngagementRow)
      .map(row => (
        <OverviewTableRow
          key={row.domain}
          row={row}
          compact={compactRows}
          showHospitalDomainScores={showHospitalDomainScores}
        />
      ))
    ) : (
      <div />
    );
    const datasetEntityName = summaryReport.datasetEntityName
      ? summaryReport.datasetEntityName
      : summaryReport.system === "AHSFHMG" ? "Region" : "Facility";
    const datasetUnitName = summaryReport.datasetUnitName ? summaryReport.datasetUnitName : "Work Setting";
    var overviewBodyClassName = survey === "SCOR" ? "breathing-room" : "";
    if (landscape) overviewBodyClassName += ' landscape';

    const showEngagement = configuration.show_engagement || survey ==='SCORE' || survey === 'SELECT_2020' || survey === 'SHA_2020';

    //const showOverallScore = summaryReport.id != '18f91942-1324-1ef4-1bd0-15cf11c01f40' && (engagementScores.find(x => x.overall) || cultureScores.find(x => x.overall));
    const columnCount = showOverallScore || (domainScores.unit && showHospitalDomainScores) ? 4 : 3;
    return (
      <div>
        <OverviewBody className={overviewBodyClassName}>
          <Grid columns={columnCount} textAlign="center" stretched>
            <Grid.Row className="no-pad-bottom-row">
              <Grid.Column />
              {!domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetEntityName} <br /> Percent Positive
                  </Header> 
                </Grid.Column>
              )}
              {!domainScores.unit &&
                showOverallScore && (
                  <Grid.Column>
                    <Header as="h4" className="column-header">
                      Select Medical<br /> Percent Positive
                    </Header>
                  </Grid.Column>
                )}

              {!domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetEntityName} <br /> Benchmark Percentile<sup>†</sup>
                  </Header>
                </Grid.Column>
              )}
              {domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetUnitName} <br /> Percent Positive
                  </Header>
                </Grid.Column>
              )}
              {domainScores.unit &&
                showHospitalDomainScores && (
                  <Grid.Column>
                    <Header as="h4" className="column-header">
                      {datasetEntityName} <br /> Percent Positive
                    </Header>
                  </Grid.Column>
                )}
              {domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetUnitName} <br /> Benchmark Percentile<sup>†</sup>
                  </Header>
                </Grid.Column>
              )}
            </Grid.Row>

            <Grid.Row textAlign="left" columns={1} className="no-pad-top-row">
              <Grid.Column textAlign="left">
                <Header as="h3">Culture</Header>
              </Grid.Column>
            </Grid.Row>
            {mappedCultureRows}

            {!landscape && showEngagement && (
              <Grid.Row textAlign="left" columns={1} className="pad-top">
                <Grid.Column textAlign="left">
                  <Header as="h3">Engagement</Header>
                </Grid.Column>
              </Grid.Row>
            )}
            {!landscape && showEngagement && mappedEngagementRows}
          </Grid>
          
          
          
          
          
          
          
          
          
          
          
          
          {landscape && <Grid columns={domainScores.unit && showHospitalDomainScores ? 4 : 3} textAlign="center" stretched>
            <Grid.Row className="no-pad-bottom-row">
              <Grid.Column />
              {!domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetEntityName} <br /> Percent Positive
                  </Header> 
                </Grid.Column>
              )}
              {!domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetEntityName} <br /> Benchmark Percentile<sup>†</sup>
                  </Header>
                </Grid.Column>
              )}
              {domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetUnitName} <br /> Percent Positive
                  </Header>
                </Grid.Column>
              )}
              {domainScores.unit &&
                showHospitalDomainScores && (
                  <Grid.Column>
                    <Header as="h4" className="column-header">
                      {datasetEntityName} <br /> Percent Positive
                    </Header>
                  </Grid.Column>
                )}
              {domainScores.unit && (
                <Grid.Column>
                  <Header as="h4" className="column-header">
                    {datasetUnitName} <br /> Benchmark Percentile<sup>†</sup>
                  </Header>
                </Grid.Column>
              )}
            </Grid.Row>

            {survey === "SCORE" && (
              <Grid.Row textAlign="left" columns={1} className="no-pad-top">
                <Grid.Column textAlign="left">
                  <Header as="h3">Engagement</Header>
                </Grid.Column>
              </Grid.Row>
            )}
            {survey === "SCORE" && mappedEngagementRows}
          </Grid>}

        </OverviewBody>
        <OverviewFooter>
          {!/SOPS/.test(survey) && 
          <div>
            <p>
              * Percent who responded positively to most questions in the domain. Domain scores may feel lower as they're
              not simple averages.
            </p>
            <p>† {benchmarkFootnote}</p>
            <p>‡ Scores reflect percent who state they and others are NOT experiencing burnout.</p>
          </div>
          }
          {/SOPS/.test(survey) && <div>
            <p>† {benchmarkFootnote}</p>
          </div>}
        </OverviewFooter>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/DomainScores/components/OverviewTable/index.jsx